import React from 'react'
import styled from 'styled-components'

import { findDOMNode } from 'react-dom'

import { connect } from 'react-redux'
import * as actions from '../../actions'

import SpeakerIcon from '../visuals/Speaker'
import ProgressBar from '../visuals/ProgressBar'

const VolueControlWrap = styled.div`
  width: 100%;
  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`

const mapStateToProps = (state) => ({
  volume: state.currentTrack.volume
})

const mapDispatchToProps = (dispatch) => ({
  setVolume: (volume) => dispatch(actions.setVolume(volume))
})

class VolumeControl extends React.Component {
  constructor (props) {
    super(props)
    this.progressBar = null
    this.moveEvent = null
    this.upEvent = null
  }

  onVolumeDown = (event) => {
    event.preventDefault()

    this.onVolumeChange(event)

    // Add the mouse move event dynamically
    this.moveEvent = window.addEventListener('mousemove', this.onVolumeChange)
    this.upEvent = window.addEventListener('mouseup', this.onVolumeChangeDone)
  }

  onVolumeChange = (event) => {
    const referencePoint = this.progressBar.getBoundingClientRect().left
    const mouse = event.clientX
    const pos = mouse - referencePoint
    const width = this.progressBar.getBoundingClientRect().width

    const percent = (pos / width).clamp(0, 1)
    this.props.setVolume(percent)
  }

  onVolumeChangeDone = (event) => {
    window.removeEventListener('mousemove', this.onVolumeChange)
    window.removeEventListener('mouseup', this.onVolumeChangeDone)
  }

  render () {
    return (
      <VolueControlWrap>
        <SpeakerIcon />
        <ProgressBar
          ref={ref => this.progressBar = findDOMNode(ref)}
          onMouseDown={this.onVolumeDown}
          value={this.props.volume}
          max={1}
          width={110}
          shadow={false}
          progressColor='#f1f1f1'
        />
      </VolueControlWrap>
    )
  }
}

VolumeControl = connect(
  mapStateToProps,
  mapDispatchToProps
)(VolumeControl)

export default VolumeControl

Number.prototype.clamp = function (min, max) {
  return Math.min(Math.max(this, min), max);
}



// WEBPACK FOOTER //
// ./src/components/Bottombar/VolumeControl.js